export default {
  props: {
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },

  computed: {
    /**
     * Returns online exclusive flag
     * @returns {boolean}
     */
    onlineExclusive() {
      return this.product && this.product.bylOnlineExclusive === true;
    },

    /**
     * Returns Coming soon flag
     * @returns {boolean}
     */
    comingSoon() {
      return this.product && this.product.bylComingSoon === true;
    },

    isSoldOut() {
      return !this.product.available;
    },

    isComingSoon() {
      return this.isSoldOut && this.product.bylComingSoon;
    },

    isOnlineExclusive() {
      return this.product.bylOnlineExclusive;
    },

    customTag() {
      return this.product?.bylCustomTag;
    },

    isCustomTag() {
      return (
        this.product && this.customTag !== undefined && this.customTag !== null
      );
    },

    isCustomTagVisibleInCategory() {
      const currentCategory =
        this.type !== 'search' && parseInt(this.plpCategory?.id, 10);
      return (
        this.isCustomTag &&
        // checks if the current category is in the hide array
        !(
          currentCategory &&
          this.customTag?.hide_in_categories?.includes(currentCategory)
        )
      );
    },

    iframeUrl() {
      return this.product?.bylWannaUrl;
    },
  },

  methods: {},
};
